const SALESFORCE_WEB_TO_LEAD_URL =
  'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8'
const FORM_ID = 'hxcDevicesForm'
const IFRAME_NAME = 'hxcdevices'
const SUBMIT_TIMEOUT_MS = 15_000

type SalesforceLeadValue = string | number | boolean | null | undefined

export type SalesforceLeadPayload = Record<string, SalesforceLeadValue>

export const submitToSalesforce = async (
  payload: SalesforceLeadPayload,
): Promise<void> => {
  const iframe = document.getElementById(
    IFRAME_NAME,
  ) as HTMLIFrameElement | null

  if (!iframe) {
    throw new Error('Salesforce submission iframe is unavailable.')
  }

  const form = document.createElement('form')
  form.id = FORM_ID
  form.method = 'POST'
  form.action = SALESFORCE_WEB_TO_LEAD_URL
  form.target = IFRAME_NAME

  Object.entries(payload).forEach(([name, value]) => {
    if (value === undefined || value === null) return

    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = String(value)
    form.appendChild(input)
  })

  try {
    await new Promise<void>((resolve, reject) => {
      const timeout = window.setTimeout(() => {
        cleanup()
        reject(new Error('Salesforce submission timed out.'))
      }, SUBMIT_TIMEOUT_MS)

      const handleLoad = () => {
        cleanup()
        resolve()
      }

      const cleanup = () => {
        window.clearTimeout(timeout)
        iframe.removeEventListener('load', handleLoad)
      }

      iframe.addEventListener('load', handleLoad, { once: true })
      document.body.appendChild(form)
      form.submit()
    })
  } finally {
    form.remove()
  }
}

export const SALESFORCE_IFRAME_PROPS = {
  id: IFRAME_NAME,
  name: IFRAME_NAME,
} as const
